import { Channel, NotificationChannels, TrackedChannel } from "../model/model";

export class TrackingMapper {
  static channelToTracked(channel: Channel): TrackedChannel {
    switch (channel) {
      case Channel.WEB:
        return TrackedChannel.NC;
      case Channel.EMAIL:
        return TrackedChannel.EMAIL;
      case Channel.PUSH:
        return TrackedChannel.PUSH;
      default:
        throw new Error(`Unknown channel ${channel}`);
    }
  }

  static notificationChannelsToTrackedChannels(
    notifications: NotificationChannels
  ): TrackedChannel[] {
    return Object.entries(notifications)
      .filter(([, enabled]) => enabled)
      .map(([channel]) => this.channelToTracked(channel as Channel));
  }
}
